import { defineSlotRecipe } from "@pandacss/dev";

export const aromaAlert = defineSlotRecipe({
  slots: ["icon", "title", "description", "root", "content", "closeButton"],
  jsx: ["Alert"],
  className: "aroma-alert",
  base: {
    root: {
      borderWidth: "m",
      borderRadius: "l",
      borderStyle: "solid",
      display: "flex",
      gap: "gap.2",
      px: "padding.4",
      py: "padding.4",
      textStyle: "paragraph.m.regular",
      textAlign: "left",
      alignItems: "center",
      color: "content.neutral.base.bold",
    },
    content: {
      display: "flex",
      flexDirection: "column",
      gap: "gap.1",
      width: "100%",
    },
    icon: {
      alignSelf: "flex-start",
      fontSize: "{sizes.xs}",
    },
    closeButton: {
      alignSelf: "flex-start",
      cursor: "pointer",
      fontSize: "large",
    },
    title: {
      textStyle: "title.s",
    },
    description: {
      textStyle: "paragraph.m.regular",
    },
  },
  variants: {
    function: {
      neutral: {
        root: {
          borderColor: "border.neutral.bold",
          backgroundColor: "background.neutral.base.subtler",
        },
        icon: {
          color: "content.neutral.base.subtle",
        },
      },
      information: {
        root: {
          borderColor: "border.functional.info",
          backgroundColor: "background.functional.info.subtle",
        },
        icon: {
          color: "content.functional.info",
        },
      },
      success: {
        root: {
          borderColor: "border.functional.success",
          backgroundColor: "background.functional.success.subtle",
        },
        icon: {
          color: "content.functional.sucess",
        },
      },
      warning: {
        root: {
          borderColor: "border.functional.warning",
          backgroundColor: "background.functional.warning.subtle",
        },
        icon: {
          color: "content.functional.warning",
        },
      },
      error: {
        root: {
          borderColor: "border.functional.error",
          backgroundColor: "background.functional.error.subtle",
        },
        icon: {
          color: "content.functional.error",
        },
      },
    },
    // whiteLabel Theme only
    reversed: {
      true: {
        root: {
          _withinWhiteLabelTheme: {
            color: "content.neutral.subtle",
            borderColor: "border.neutral-on-brand.bold",
            backgroundColor: "transparent",
          },
        },
        icon: {
          _withinWhiteLabelTheme: {
            color: "content.neutral.subtle",
          },
        },
        title: {
          _withinWhiteLabelTheme: {
            color: "content.neutral.bold",
          },
        },
        description: {
          _withinWhiteLabelTheme: {
            color: "content.neutral.subtle",
          },
        },
      },
    },
  },
  defaultVariants: {
    function: "neutral",
  },
});
